<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="id">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">法人編集</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt width="25" height="25" />
      <p class="title-bk">法人登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'corporation-id-edit' : 'corporation-add', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">以下の内容で登録しますか？</th>
            <td />
          </tr>
          <tr>
            <th scope="row">法人ID</th>
            <td>{{ currentCorporation.uid }}</td>
          </tr>
          <tr>
            <th scope="row">法人名</th>
            <td>{{ currentCorporation.name }}</td>
          </tr>
          <tr>
            <th scope="row">法人名（フリガナ）</th>
            <td>{{ currentCorporation.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">郵便番号</th>
            <td>{{ currentCorporation.postalCode }}</td>
          </tr>
          <tr>
            <th scope="row">都道府県 市区町村</th>
            <td>{{ currentCorporation.state }}</td>
          </tr>
          <tr>
            <th scope="row">番地・建物名</th>
            <td>{{ currentCorporation.address }}</td>
          </tr>
          <tr>
            <th scope="row">電話番号</th>
            <td>{{ currentCorporation.phone }}</td>
          </tr>
          <tr>
            <th scope="row">FAX番号</th>
            <td>{{ currentCorporation.fax }}</td>
          </tr>
          <tr>
            <th scope="row">メールアドレス</th>
            <td>{{ currentCorporationEmail }}</td>
          </tr>
          <tr>
            <th scope="row">利用教材</th>
            <td>{{ currentCorporationProducts }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button type="button" class="btn-confirm" @click="confirmRevised">修正</button>
        <button type="button" class="btn-red" @click="confirmSaved" :disabled="isLoading">登録</button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="法人情報に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header v-if="id">法人編集</template>
        <template v-slot:header v-else>法人登録</template>
        <template v-slot:body v-if="id">法人の登録情報の編集が完了しました！</template>
        <template v-slot:body v-else>法人の登録が完了しました！</template>
      </PopUpHolder>
      <b-alert variant="danger" v-show="errorMessage" dismissible show>{{ errorMessage }}</b-alert>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import { basicPresent, basicProductName } from '@/presenters/fields';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import sortBy from 'lodash/sortBy';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  components: {
    PopUpHolder,
  },
  data() {
    return {
      errorMessage: null,
      isLoading: false,
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      if (store.getters['corporation/existsUpdateRequiredParams']) {
        store.dispatch('corporation/fetchCorporation', routeTo.params.id).then(() => {
          next();
        });
      } else {
        next({ name: 'corporation-id-edit', params: { id: routeTo.params.id } });
      }
    } else {
      if (store.getters['corporation/existsRegistrationRequiredParams']) {
        next();
      } else {
        next({ name: 'corporation-add' });
      }
    }
  },
  computed: {
    currentCorporation() {
      if (this.corporation.editingCorporation) {
        return this.corporation.editingCorporation;
      } else {
        return this.corporation.corporation;
      }
    },
    currentCorporationEmail() {
      return basicPresent(this.currentCorporation.email);
    },
    currentCorporationProducts() {
      if (Array.isArray(this.currentCorporation.figuredProducts)) {
        const sortedProducts = sortBy(this.currentCorporation.figuredProducts, 'position');
        return basicProductName(sortedProducts);
      }
      return basicPresent();
    },
    ...mapState(['corporation']),
  },
  methods: {
    confirmRevised() {
      if (this.id) {
        // This path is for Editing existing Corporation flow
        this.$logger.debug('Need revise, go back to ID ' + this.id);
        this.$router.push({ name: 'corporation-id-edit', params: { id: this.id } });
      } else {
        // This path is for Adding new Corporation flow
        this.$logger.debug('Need revise, go back');
        this.$router.push({ name: 'corporation-add' });
      }
    },
    confirmSaved() {
      this.$logger.debug('Finished Editing: ' + JSON.stringify(this.currentCorporation));
      if (this.id) {
        // This path is for Editing existing Corporation flow
        this.finishEditingCorporation(this.id).then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      } else {
        this.isLoading = true;
        // This path is for Adding new Corporation flow
        this.finishEditingCorporation().then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.isLoading = false;
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      }
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      if (this.id) {
        this.$router.push({ name: 'corporation-id-detail', params: { id: this.id } });
      } else {
        this.$router.push({ name: 'corporation' });
      }
    },
    ...mapActions('corporation', ['finishEditingCorporation']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
